//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/TransientObject.js";
let d=[[[0,"FullCycle",1,0]],[[["animState"],"AnimateContour",{},1,0],[[],"Dispose",{},0,0]],[]];
SPLM.DesignSimulation.AnimationController = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.AnimationController";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.AnimationController.State = Object.freeze({
    "Play" : "Play", "Stop" : "Stop", "Pause" : "Pause", "Next" : "Next", "Previous" : "Previous"});

export default SPLM;